import React from 'react';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import {
    Link,
} from "react-router-dom";
import Form from 'react-bootstrap/Form';

import UserPhoto from '../../../../components/user-photo/user-photo';
import LoadingOverlay from '../../../../components/loading-ovelay/loading-overlay';

import { GetProfile, EditProfile } from '../../../../services/api/profile-api';
import { LoginContext } from '../../../../services/api/authentication-api';
import { trackPromise } from 'react-promise-tracker';
import { Formik } from 'formik';
import { ToBase64 } from '../../../../services/api/file-api';
import * as yup from 'yup';
import { OLD_UI_URL } from '../../../../services/api/api-client';

import './profile-edit-panel.scss';

// redux
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { selectUser } from '../../../../redux/user/user-selector';

//Delete MVC
class ProfileEditPanel extends React.Component {

    constructor(Props) {
        super(Props)

        this.state = {
            profile: {},
            loaded: false,
            passwordType: 'password',
            confPasswordType: 'password',
        }
    }

    componentDidMount = () => {
        //ADD PHONE AND ABOUT ME FIELDS TO GETUSERPROFILEAPI 
        trackPromise(
            GetProfile(this.context.userID).then(
                (profile) => {
                    this.setState({
                        profile: { ...profile, phone: "111-111-1111", aboutMe: "ABOUT ME", passwordConfirmation:profile.password },
                        loaded: true,

                    });
                },
                (error) => {
                    this.setState({
                        showAlert: true,
                        alertAction: "Could not get profile.",
                        alertMessage: "",
                        alertVariant: "danger",
                    })
                }
            ), "profile-edit-panel-area"
        )
    }

    loadImage(src) {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.addEventListener("load", () => resolve(img));
            img.addEventListener("error", err => reject(err));
            img.src = src;
        });
    }

    editProfile = (profile) => {
        profile = { ...profile, profileImage: this.state.profile.profileImage, profileImageRaw: this.state.profile.profileImageRaw }
        if(profile.profileImage.includes("https://")){
            profile.profileImage = this.getBase64FromImageUrl(profile.profileImage);
        }
        trackPromise(
            EditProfile(profile).then(
                (result) => {
                    this.setState({
                        showAlert: true,
                        alertAction: "Profile Successfully Edited.",
                        alertMessage: "",
                        alertVariant: "success",
                    });
                },
                (error) => {
                    this.setState({
                        showAlert: true,
                        alertAction: "Could not edit profile.",
                        alertMessage: "",
                        alertVariant: "danger",
                    });
                }
            ), "profile-edit-panel-area"
        )
    }

    getBase64FromImageUrl =(URL) => {
        var img = new Image();
        img.setAttribute('crossOrigin', 'anonymous');
        img.src = URL;
        img.onload = function() {
    
            var canvas = document.createElement("canvas");
            canvas.width = this.width;
            canvas.height = this.height;
    
            var ctx = canvas.getContext("2d");
            ctx.drawImage(this, 0, 0);
    
            var dataURL = canvas.toDataURL("image/png");
        };
    }

    onProfilePictureUploaded = (e) => {
        let file = e.target.files[0];
        const validImageTypes = ['image/jpeg', 'image/png', 'image/bmp', 'image/tiff', 'image/gif'];

        if (!validImageTypes.includes(file.type)) {
            this.setState({
                showAlert: true,
                alertAction: "Invalid Picture Format.",
                alertMessage: "Image must be either jpg, png, bmp, tiff, or gif.",
                alertVariant: "danger",
            });
            return;
        }
        else {
            // check file size
            if (file.size > 2000000) {
                this.setState({
                    showAlert: true,
                    alertAction: "File size too large.",
                    alertMessage: "Image must be less than 2MB.",
                    alertVariant: "danger",
                });
                return;
            }

            ToBase64(file).then(
                (result) => {
                    // set the profile image
                    this.setState({
                        profile: { ...this.state.profile, profileImageRaw: result, profileImage: result.split(',')[1] }
                    });
                }
            );
        }
    }

    clearImage = (event) => {
        event.preventDefault();
        this.setState({ profile: { ...this.state.profile, profileImage: "", profileImageRaw: "" } });
    }

    showHidePassword = (event, passType) => {
        event.preventDefault();

        passType === "password" ?
        (this.setState({ passwordType: this.state.passwordType === 'password' ? 'text' : 'password' })):
        (this.setState({ confPasswordType: this.state.confPasswordType === 'password' ? 'text' : 'password' }))
    }

    displayAlert() {

        this.timer = window.setTimeout(() => {
            this.setState({ showAlert: false });
        }, 5000);

        return <Alert show={this.state.showAlert} onClose={() => this.setState({ showAlert: false })} variant={this.state.alertVariant} dismissible>
            <Alert.Heading>{this.state.alertAction}</Alert.Heading>
            <p>{this.state.alertMessage}</p>
            <hr />
            <div className="d-flex justify-content-end">
            </div>
        </Alert>
    }

    render = () => {
        return (
            <div className="profile-edit-panel">
                <LoadingOverlay area="profile-edit-panel-area" />
                {
                    this.state.showAlert ?
                        this.displayAlert()
                        : <></>
                }
                <Formik
                    key={this.state.loaded}
                    validationSchema={yup.object({
                        userNameFull: yup.string().required("Username required"),
                        userEmail: yup.string().required("Username required").email("Enter a valid email"),
                        password: yup.string().min(6, "Password must be between 6-26 characters in length").max(26, "Password must be between 6-26 characters in length").required("Password Required").nullable(),
                        passwordConfirmation: yup.string().oneOf([yup.ref('password')], "Passwords must match").required("Passwords must match").nullable(),
                    })}
                    initialValues={
                        this.state.profile
                    }
                    onSubmit={(values) => { this.editProfile(values) }}
                    validator={() => ({})}
                >
                    {({
                        handleSubmit,
                        handleChange,
                        values,
                        touched,
                        errors,
                        setFieldValue,
                    }) => (
                            <Form onSubmit={handleSubmit} className="create-container">
                                <div className="left-col">
                                    <Form.Row>
                                        <Form.Group className="picture">
                                            <UserPhoto key={this.state.profile.profileImage} photoBase64={this.state.profile.profileImageRaw} photo={this.state.profile.profileImage === "" ? OLD_UI_URL + "ApplicationDocuments/Files/202006250330536082.png" : this.state.profile.profileImage} name={values.userNameFull} className="picture-icon"></UserPhoto>
                                            <div className="choose-img-btn-container">
                                            <Button className="btn-wide choose-img-button">
                                                <Form.Control
                                                    name="user-photo"
                                                    id="user-photo"
                                                    label="Upload Profile Image"
                                                    className="upload-image-button"
                                                    type="file"
                                                    onChange={(e) => { this.onProfilePictureUploaded(e) }}
                                                />
                                                <div className="camera"></div>
                                                <div className="label-spacing">Upload Profile Image</div>
                                            </Button>
                                            <Button className="btn-wide clear choose-img-button" onClick={(e) => { this.clearImage(e) }}>
                                                <div className="camera-clear"></div>
                                                <div className="label-spacing">Clear Image</div>
                                            </Button>
                                            </div>
                                        </Form.Group>

                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group>
                                            <Form.Label>Full Name</Form.Label>
                                            <Form.Control
                                                id="userNameFull"
                                                name="userNameFull"
                                                value={values.userNameFull}
                                                onChange={(e) => { handleChange(e) }}
                                                placeholder="Enter Name"
                                                isInvalid={touched.userNameFull && errors.userNameFull}
                                            />
                                            <Form.Control.Feedback type="invalid">{errors.userNameFull}</Form.Control.Feedback>
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        {false &&
                                            <Form.Group>
                                                <Form.Label>Mobile</Form.Label>
                                                <Form.Control
                                                    name="phone"
                                                    value={values.phone}
                                                    onChange={(e) => { handleChange(e) }}
                                                    placeholder="Mobile"
                                                // isInvalid={touched.phone && errors.phone}
                                                />
                                                {/* <Form.Control.Feedback type="invalid">{errors.phone}</Form.Control.Feedback> */}
                                            </Form.Group>
                                        }
                                        <Form.Group>
                                            <Form.Label>Email</Form.Label>
                                            <Form.Control
                                                id="userEmail"
                                                type="email"
                                                name="userEmail"
                                                value={values.userEmail}
                                                onChange={handleChange}
                                                placeholder="Email"
                                                isInvalid={touched.userEmail && errors.userEmail}
                                            />
                                            <Form.Control.Feedback type="invalid">{errors.userEmail}</Form.Control.Feedback>
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row className="btn-container">
                                        <Button type="submit" className="btn-wide" variant="primary">Save</Button>
                                        <Link to="/profile"><Button className="btn-wide btn-outlined btn" variant="primary" >Back</Button></Link>
                                    </Form.Row>
                                </div>
                                <div className="right-col">
                                    <Form.Group controlId="formDescription">
                                        <Form.Label>About Me</Form.Label>
                                        <Form.Control
                                            name="aboutMe"
                                            as="textarea" rows="6"
                                            value={values.aboutMe}
                                            onChange={(e) => { handleChange(e) }}
                                            placeholder="Description"
                                        // isInvalid={touched.aboutMe && errors.aboutMe}
                                        />
                                        {/* <Form.Control.Feedback type="invalid">{errors.aboutMe}</Form.Control.Feedback> */}
                                    </Form.Group>

                                    {
                                        !this.props.user.profile.isSSO &&

                                        <Form.Group className="password-fields">
                                            <Form.Group>
                                                <Form.Label>Password *</Form.Label>
                                                <Button className='view-icon' onClick={(e) => {this.showHidePassword(e, "password")}} />
                                                <Form.Control
                                                    autoComplete="off"
                                                    type={this.state.passwordType}
                                                    name="password"
                                                    id="password"
                                                    placeholder="Password"
                                                    value={values.password}
                                                    onChange={handleChange}
                                                    isInvalid={touched.password && errors.password}
                                                />
                                                <Form.Control.Feedback type="invalid">{errors.password}</Form.Control.Feedback>
                                            </Form.Group>
                                            <Form.Group>
                                                <Form.Label>Confirm Password *</Form.Label>
                                                <Button className='view-icon' onClick={(e) => {this.showHidePassword(e, "confpassword")}} />
                                                <Form.Control
                                                    autoComplete="off"
                                                    type={this.state.confPasswordType}
                                                    id="passwordConfirmation"
                                                    disabled={values.password === "" || values.password === undefined}
                                                    placeholder="Confirm Password"
                                                    value={values.passwordConfirmation}
                                                    onChange={handleChange}
                                                    isInvalid={errors.passwordConfirmation}
                                                />
                                                <Form.Control.Feedback type="invalid">{errors.passwordConfirmation}</Form.Control.Feedback>
                                            </Form.Group>
                                        </Form.Group>
                                    }
                                </div>
                            </Form>
                        )}
                </Formik>
            </div>
        )
    }
}

const mapState = createStructuredSelector({
    user: selectUser,
})

ProfileEditPanel.contextType = LoginContext;
export default connect(mapState, null)(ProfileEditPanel);